import React, { useRef } from "react";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import { motion, useInView } from "framer-motion";

const services = [
  {
    title: "ERP System Development",
    desc: "Complete ERP solutions for business operations including sales, inventory, purchasing, and reporting modules.",
  },
  {
    title: "Accounting & Financial Systems",
    desc: "Full accounting systems including journal entries, ledgers, VAT (TVA), payroll, and financial reporting.",
  },
  {
    title: "Chief Accounting & Financial Control",
    desc: "Experience in managing accounting processes, financial closing, cost control, and decision-making support.",
  },
  {
    title: "Web Applications",
    desc: "Modern responsive web applications built with React, Node.js, Laravel, and database integration.",
  },
  {
    title: "Desktop Applications",
    desc: "Powerful desktop systems using C# / WinForms / SQL Server for accounting, inventory, and POS systems.",
  },
  {
    title: "Mobile & Cross-Platform Apps",
    desc: "Mobile-friendly and cross-platform applications with modern UI and backend integration.",
  },
];

const Services = () => {
  const ref = useRef(null);

  // ✅ FIXED useInView
  const isInView = useInView(ref, {
    once: true,
    amount: 0.2,
  });

  return (
    <Box
      ref={ref}
      id="services"
      sx={{
        py: { xs: 8, md: 10 },
        px: 3,
        backgroundColor: "#fff",
        color: "#000",
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      <Box maxWidth="1100px" mx="auto">

        {/* TITLE */}
        <motion.div
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={{
            hidden: { opacity: 0, y: 50 },
            visible: { opacity: 1, y: 0 },
          }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="h4"
            sx={{ textAlign: "center", fontWeight: 700 }}
          >
            My Services
          </Typography>

          <Typography
            sx={{
              textAlign: "center",
              color: "#555",
              mb: 6,
            }}
          >
            ERP • Accounting • Financial Control • Business Management
          </Typography>
        </motion.div>

        {/* CARDS */}
        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              
              <motion.div
                initial="hidden"
                animate={isInView ? "visible" : "hidden"}
                variants={{
                  hidden: { opacity: 0, y: 60 },
                  visible: { opacity: 1, y: 0 },
                }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.15,
                }}
              >
                <Card
                  sx={{
                    height: "100%",
                    borderRadius: 3,
                    backgroundColor: "#fff",
                    border: "1px solid #eee",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                    transition: "0.3s",

                    "&:hover": {
                      transform: "translateY(-8px)",
                      boxShadow: "0 12px 35px rgba(0,0,0,0.15)",
                    },
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 700, mb: 2 }}
                    >
                      {service.title}
                    </Typography>

                    <Typography
                      sx={{
                        color: "#555",
                        lineHeight: 1.7,
                        fontSize: "14px",
                      }}
                    >
                      {service.desc}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>

            </Grid>
          ))}
        </Grid>

      </Box>
    </Box>
  );
};

export default Services;